import Typography from '@mui/material/Typography';

interface AssetTabPlaceholderProps {
  tabName: string;
}

/**
 * Temporary placeholder for asset detail tabs that have not yet been implemented.
 * Each stub tab shows its own name so the layout is clear during development.
 */
export function AssetTabPlaceholder({ tabName }: AssetTabPlaceholderProps) {
  return (
    <div className="py-8 flex justify-center">
      <Typography variant="body2" color="text.secondary">
        {tabName} — coming soon.
      </Typography>
    </div>
  );
}
